import to from "await-to-js";
import { giftQuery } from "@/common-components-src/api/gift/gift.api";

export const getGift = async () => {
  const [err, result] = await to(giftQuery());
  console.log("result---login------GiftModal", result);
};
